import { Select, Tag } from 'antd';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

export const SelectRenderer = ({
	field,
	value,
	onChange,
	mode,
	size,
	disabled = false,
	placeholder,
}: TFieldRendererProps) => {
	const options =
		field.options?.map((option) => ({
			label: option,
			value: option,
		})) || [];

	if (mode === EFieldMode.DISPLAY) {
		if (!value) {
			return <span>-</span>;
		}
		return <Tag color="blue">{value as string}</Tag>;
	}

	return (
		<Select
			value={value}
			onChange={onChange}
			options={options}
			size={size}
			disabled={disabled}
			placeholder={placeholder || `Select ${field.fieldName.toLowerCase()}`}
			allowClear
			showSearch
			optionFilterProp="label"
		/>
	);
};
